import { IObj2d, IObj3d } from "../models/IObj";
import { IVec2d, IVec3d } from "../services/WebApiClient";


export type SvgSize = { width: number; height: number; };
export type SvgPos = { x: number, y: number };

export class FrontPosConverter {

    constructor(private readonly cabinetHeight: number) { }
    size(size: IVec2d): SvgSize {
        return {
            width: size.x,
            height: size.y
        };
    }
    pos(pos: IVec2d, size: IVec2d = { x: 0, y: 0 }): SvgPos {
        return {
            x: pos.x,
            y: this.cabinetHeight - pos.y - size.y
        };
    }

    obj(obj: IObj2d): SvgPos & SvgSize {
        return {
            ...this.size(obj.size),
            ...this.pos(obj.position, obj.size)
        };
    }

    reversePos(pos: SvgPos): IVec2d {
        return {
            x: pos.x,
            y: this.cabinetHeight - pos.y
        };
    }

    getFlipTransformString(obj: IObj2d): string {
        const svgObj = this.obj(obj);
        return `translate(${2 * svgObj.x + svgObj.width}, 0) scale(-1,1)`
    }

}

export class TopPosConverter {

    size(size: IVec3d): SvgSize {
        return {
            width: size.x,
            height: size.z
        };
    }

    pos(pos: IVec3d, size: IVec3d): SvgPos {
        return {
            x: pos.x,
            y: pos.z
        };
    }

    obj(obj: IObj3d): SvgPos & SvgSize {
        return {
            ...this.size(obj.size),
            ...this.pos(obj.position, obj.size)
        };
    }
}
